import { useEffect, useState } from "react";
import { apiJson } from "../../utils/api.js";

const TrashIcon = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 6h18" />
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
    <line x1="10" x2="10" y1="11" y2="17" />
    <line x1="14" x2="14" y1="11" y2="17" />
  </svg>
);

function pill(text) {
  return <div className="pill">{text}</div>;
}

export function GroupRow({ group, allManagers, onChanged }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [error, setError] = useState(null);
  const [addMid, setAddMid] = useState("");
  const [addBusy, setAddBusy] = useState(false);
  const [assignBusy, setAssignBusy] = useState(false);

  const assignmentsEnabled = group.assignments_enabled !== false;

  const memberIds = new Set((members || []).map((m) => m.id));
  const gid = Number(group.id);
  const notInGroup = (allManagers || []).filter((m) => {
    if (!m.is_active || memberIds.has(m.id)) return false;
    const dept = m.department_group_id;
    if (dept == null || dept === undefined) return true;
    return Number(dept) === gid;
  });

  async function loadMembers() {
    setLoading(true);
    setError(null);
    try {
      const data = await apiJson(`/api/admin/groups/${group.id}/members`);
      setMembers(data.items || []);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!open) return;
    if (!members.length && !loading && !error) {
      loadMembers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <div className="settingsRow groupRow">
      <div className="groupRowHeader">
        <button
          type="button"
          className="groupTitleBtn"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="groupTitle">{group.title}</span>
          {(group.code != null && group.code !== "") ? (
            <span className="groupCodeBadge" title="Код для ссылки: t.me/бот?start=код">{group.code}</span>
          ) : null}
          <span className="groupToggleIcon">{open ? "▲" : "▼"}</span>
        </button>
        <label
          className="groupAssignToggle"
          title="Если выключено: ссылка t.me/бот?start=код и общая раздача не назначают заявки в этот отдел; кнопка направления в боте скрыта."
        >
          <input
            type="checkbox"
            checked={assignmentsEnabled}
            disabled={assignBusy}
            onChange={async (e) => {
              const checked = e.target.checked;
              setAssignBusy(true);
              try {
                await apiJson(`/api/admin/groups/${group.id}`, {
                  method: "PATCH",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ assignments_enabled: checked }),
                });
                await onChanged?.();
              } catch (err) {
                window.alert(String(err));
              } finally {
                setAssignBusy(false);
              }
            }}
          />
          <span>Приём заявок</span>
        </label>
        <button
          type="button"
          className="groupDeleteBtn"
          title="Удалить отдел"
          aria-label="Удалить отдел"
          onClick={async (e) => {
            e.stopPropagation();
            if (!window.confirm(`Удалить отдел «${group.title}»?`)) return;
            try {
              await apiJson(`/api/admin/groups/${group.id}`, { method: "DELETE" });
              await onChanged?.();
            } catch (err) {
              window.alert(String(err));
            }
          }}
        >
          <span className="groupDeleteBtnSvg">{TrashIcon}</span>
        </button>
      </div>

      <div className={`groupParticipantsContent ${open ? "" : "hidden"}`}>
        {error ? pill(`Ошибка: ${error}`) : null}
        {group.code ? (
          <div className="groupCodeRow settingsRowActions groupParticipantsActions" style={{ marginBottom: 8 }}>
            <span className="label">Код направления:</span>
            <code className="groupCodeValue" title="Используйте в ссылке: t.me/бот?start=код">{group.code}</code>
          </div>
        ) : null}
        <div className="groupTimezoneRow settingsRowActions" style={{ marginBottom: 8 }}>
          <span className="label">Часовой пояс отдела:</span>
          <select
            className="input"
            value={group.timezone ?? ""}
            title="IANA (для расчёта смены 10–19 и подписей в задачах)"
            onChange={async (e) => {
              const v = e.target.value;
              try {
                await apiJson(`/api/admin/groups/${group.id}`, {
                  method: "PATCH",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ timezone: v || null }),
                });
                await onChanged?.();
              } catch (err) {
                window.alert(String(err));
              }
            }}
          >
            <option value="">По умолчанию (как МСК)</option>
            <option value="Europe/Moscow">МСК — Europe/Moscow</option>
            <option value="Asia/Tbilisi">МСК+1 — Asia/Tbilisi</option>
          </select>
        </div>
        {!loading && !error ? (
          members.length ? (
            <>
              <div className="settingsRowActions groupParticipantsActions">
                {notInGroup.length ? (
                  <>
                    <select
                      className="input"
                      value={addMid}
                      onChange={(e) => setAddMid(e.target.value)}
                    >
                      <option value="">+ в отдел</option>
                      {notInGroup.map((m) => (
                        <option key={String(m.id)} value={String(m.id)}>
                          {m.display_name || m.code || `tg=${m.telegram_id}`}
                        </option>
                      ))}
                    </select>
                    <button
                      type="button"
                      className="smallBtn"
                      disabled={addBusy}
                      onClick={async () => {
                        const mid = String(addMid || "").trim();
                        if (!mid) return;
                        setAddBusy(true);
                        try {
                          await apiJson(`/api/admin/groups/${group.id}/members`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ manager_id: Number(mid) }),
                          });
                          setAddMid("");
                          await loadMembers();
                          await onChanged?.();
                        } catch (e) {
                          window.alert(String(e));
                        } finally {
                          setAddBusy(false);
                        }
                      }}
                    >
                      Добавить
                    </button>
                  </>
                ) : null}
                {members.map((mem) => (
                  <button
                    key={String(mem.id)}
                    type="button"
                    className="smallBtn danger"
                    onClick={async () => {
                      try {
                        await apiJson(
                          `/api/admin/groups/${group.id}/members/${mem.id}`,
                          { method: "DELETE" },
                        );
                        await loadMembers();
                        await onChanged?.();
                      } catch (e) {
                        window.alert(String(e));
                      }
                    }}
                  >
                    ✕ {mem.display_name || mem.code || mem.telegram_id}
                  </button>
                ))}
              </div>
            </>
          ) : (
            pill("В отделе нет менеджеров")
          )
        ) : null}
      </div>
    </div>
  );
}
